/**
 * AddUserForm — handmatig een account aanmaken vanuit het adminportaal.
 *
 * WAT HIER STOND, EN WAAROM HET WEG IS
 *
 * Dit was een volledig formulier dat een account uitsluitend in localStorage
 * aanmaakte, met de oude ongesalte SHA-256-hash. Sinds de inlog via Supabase
 * loopt, levert dat een spookaccount op: het verschijnt in het overzicht, maar
 * er is geen rij in `auth.users` en geen profielrij. Niemand kan ermee
 * inloggen, en het valt buiten `data_controller`, `consent_status` en elke
 * bewaartermijn.
 *
 * Een leerlingaccount dat het hele governancemodel omzeilt is precies wat het
 * getrapte model moet uitsluiten. Het formulier stond daarom al achter een
 * blokkade — maar de velden en de aanmaakcode bleven eronder staan, en dat is
 * de gevaarlijke vorm: bij de volgende wijziging leest iemand die code als
 * levend en haalt de blokkade weg.
 *
 * WAT HIERVOOR IN DE PLAATS KOMT
 *
 * Aanmaken hoort serverside te gebeuren via de Edge Function `create-learner`
 * (service-role, `email_confirm: true`), en pas nadat er is besloten wie
 * verwerkingsverantwoordelijke is voor dat kind — een school of een ouder.
 * Zolang die keuze niet gemodelleerd is, is weigeren het juiste antwoord.
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../../../../components/ui/Button';
import type { AccountsState, AccountRole } from '../../../../accounts';
import type { CreateAccountDetails, CreateAccountOptions } from '../../../../app/store/types';
interface AddUserFormProps {
  /** Niet meer gebruikt — accounts komen van de server. */
  accounts?: AccountsState | undefined;
  /** Niet meer gebruikt — lokaal aanmaken is geen geldige route meer. */
  store?: {
    createAccount: (role: AccountRole, details: CreateAccountDetails, options?: CreateAccountOptions) => string;
  };
  onClose: () => void;
}
export function AddUserForm({
  onClose
}: AddUserFormProps) {
  return <div className="space-y-4" data-id="element-7752" data-mp="3sbbomx1pt33k">
      <div className="flex gap-3 p-4 rounded-xl bg-amber-50 border border-amber-200" data-id="element-7753" data-mp="3scmv54mjooyd">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-7754" data-mp="zgbsnal3xo8o" />
        
        <div className="text-sm text-amber-900" data-id="element-7755" data-mp="uitl9omqnh2s">
          <p className="font-bold mb-1" data-id="element-7756" data-mp="18h090bxz40oq">
            Handmatig aanmaken is uitgeschakeld
          </p>
          <p data-id="element-7757" data-mp="13hdu7y2hycdt">
            Accounts worden op de server aangemaakt. Een account dat hier werd
            gemaakt, zou alleen op dit apparaat bestaan — er kan dan niemand mee
            inloggen, en het valt buiten de bewaartermijnen en de
            toestemmingsregels.
          </p>
          <p className="mt-2" data-id="element-7758" data-mp="1r7rdp070n2ws">
            Laat gebruikers zich registreren, of koppel een leerling met een
            klas- of koppelcode.
          </p>
        </div>
      </div>
      <div className="flex justify-end" data-id="element-7759" data-mp="215f97scg4eg0">
        <Button type="button" variant="secondary" onClick={onClose} data-id="element-7760" data-mp="216gwcv6qkre3">
          Sluiten
        </Button>
      </div>
    </div>;
}